import React from 'react'
import * as firebase from "firebase";



export default class Login extends React.Component {
    constructor(props) {
        super(props)
        this.checkSignedIn = this.checkSignedIn.bind(this)
        this. handleSignOut = this. handleSignOut.bind(this)
        this.renderSignIn = this.renderSignIn.bind(this)
        this.state = {isLoggedIn: false};
        this.addUser = this.addUser.bind(this);

    }

    componentWillMount() {
        this.checkSignedIn()
    }

    signOut(){
        console.log("signing user out");
        alert("signing out");
       firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });

    }
    handleSignOut(){
        console.log("signing user out");
        alert("signing out");

    }
    checkSignedIn(){
        var state = this
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                console.log("singed in : "+ user.phoneNumber);
                state.setState({isLoggedIn:true});
                this.addUser(user.phoneNumber.replace(/\D/g, ''));
                window.location = '/#/Chat/';

            }else {
                console.log("singed out  ");
                state.setState({isLoggedIn:false});
            }
        }.bind(this));
    }
    addUser(userID){
        firebase.database().ref('users/'+userID+'/user/').set(true);
        firebase.database().ref('users/'+userID+'/last_active/').set(new Date().getTime());


    }
    renderSignIn(){
        if(this.state.isLoggedIn){
            return  <button onClick={this.signOut}>Sign Out</button>
        }else {
            return  <div id="firebaseui-auth-container"></div>

        }

    }
    render() {
        const isLoggedIn = this.state.isLoggedIn;
        return <div id="content">
            <div id="home_image_container">
                <image id ="image_home"src="/texter_hi-res icon .svg"></image>
            </div>
            <div id="play_store_container" >
                <a href='https://play.google.com/store/apps/details?id=us.mordor.AndroidMessenger&utm_source=www.texerapp.org&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img id="play_store_img"alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/></a>

            </div>
            <div id="nav_sign" > <div id="firebaseui-auth-container"></div></div>
        </div>

    }

}






// WEBPACK FOOTER //
// ./src/components/pages/Login.jsx